import React from 'react'

import Component from './component'

const Container = ({ job_ids }) => {

  const mergedProps = {
    job_ids
  }

  return (
    <Component {...mergedProps} />
  )
}

export default Container
